import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What if the market suddenly reverses right after my entry?",
    a: "That's exactly what our Auto-Transformative Adjustment feature is built for. Tradecure re-evaluates market trend in real time, and if the direction flips, it automatically re-shapes your legs — the same way institutional desks do — without you touching the screen.",
  },
  {
    q: "Do I need to know Python, Pine Script, or any coding?",
    a: "No. Zero code, zero prompts. If you can pick items for a grocery order, you can deploy a strategy on Tradecure. Everything is tiles, sliders, and rupee amounts.",
  },
  {
    q: "Is my broker account safe?",
    a: "Yes. We use your broker's official API with encrypted, read-write-limited tokens. Your money stays in your broker account. Tradecure only places orders on your behalf — we never hold funds.",
  },
  {
    q: "I trade as a side income. Will this actually fit my life?",
    a: "That's literally who we built it for. Deploy in the morning, go to your job/meetings/calls, and Tradecure handles entries, SLs, targets, trailing and live adjustments. You get a summary when the strategy closes.",
  },
  {
    q: "What brokers are supported?",
    a: "At launch — Zerodha, Angel One, Upstox and Dhan. More coming based on waitlist demand.",
  },
  {
    q: "Can I customize the pre-built strategies?",
    a: "100%. Every leg, every time window, every target and SL amount is fully editable. You can also save your tweaked version as your personal strategy.",
  },
  {
    q: "What does 'risk in rupees' actually mean?",
    a: "Instead of thinking in percentages, Greeks or margins, you simply set 'I'm okay losing up to ₹2,500 on this trade'. Tradecure sizes the position, sets SL, and respects that hard limit. No surprises.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="mx-auto max-w-4xl px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="font-mono text-xs font-bold text-[#084392] tracking-[0.2em]">
            / QUESTIONS
          </div>
          <h2 className="font-heading mt-3 text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter">
            Everything you&rsquo;re
            <br />
            about to ask.
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#e2e8f0]">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-heading text-lg md:text-xl font-bold text-[#0f172a] hover:text-[#084392] py-5"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-[#475569] text-base leading-relaxed pb-5"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
